<template>
    <div class="wrap-map-list">
        <div class="world-map-img">
            <img :src=worldmap.mapUrl alt="" @click.self="hideAllBubbles()">
            <div class="pin-wrap"
                 v-for="(destination, index) in worldmap.destinations"
                 v-if="destination.posX > 0"
                 :style="{ left: destination.posX + '%', top: destination.posY + '%' }"
                 :class="destination.slug"
                 @mouseenter="showBubble(destination)"
                :key="index"
            >
                <div class="pin-gris"></div>
                <div class="pin-rouge"></div>
                <div class="pin-content"
                     :style="{ backgroundImage: 'url(' + destination.imgUrl + ')' }"
                     @mouseleave="hideAllBubbles(destination)"
                     @click="goToUrl(destination.url)"
                >
                    <div class="overlay"></div>
                    <p class="name" v-html="destination.name"></p>
                    <p class="discover" v-html="formatCruiseCount(destination.count)"></p>
                </div>
            </div>
        </div>
        <ul class="destination-list">
            <div class="desc-wrap">
                <p v-html="descTitle" class="head"></p>
                <p v-html="desc" class="body"></p>
            </div>
            <li v-for="(destination, index) in worldmap.destinations">
                <a :href="destination.url"
                   @mouseenter="showPanel(), listLinkHover = true, updateContent(destination)"
                   @mouseleave="hidePanel(), listLinkHover = false"
                   v-html="formatListItem(destination.name, destination.count)"
                ></a>
            </li>
        </ul>
    </div>
</template>

<script>
    import $ from 'jquery';
    import {debounce} from 'lodash';
    import {breakpointUp} from '../../libs/Breakpoints';

    export default {
        props: {
            worldmap: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                listLinkHover: false,
                descTitle: 'Arctique',
                desc: `Lorem ipsum orci eget a tempor vel consectetur porta risus dolor.
                Consectetur massa consequat ornare. Ac viverra tortor leo, per arcu iaculis.
                Dui sed dolor. Eu turpis vitae sagittis in Suspendisse iaculis, sollicitudin purus`,
            };
        },
        computed: {},
        methods: {
            showPanel() {
                if (breakpointUp('lg')) {
                    $('.destination-list .desc-wrap').fadeIn(200).css('transform', 'translateX(-100%)');
                }

            },
            hidePanel: debounce(function () {
                if (this.listLinkHover === false) {
                    $('.destination-list .desc-wrap').fadeOut().css('transform', 'translateX(-105%)');
                    this.listLinkHover = false;

                }
            }, 300),
            updateContent(destination) {
                this.descTitle = destination.name;
                this.desc = destination.desc;
            },
            formatCruiseCount(count) {
                return count > 1 ? count + ' voyages à découvrir' : count + ' voyage à découvrir';
            },
            showBubble(destination) {
                this.hideAllBubbles();
                $('.pin-wrap.' + destination.slug).css('z-index', '20');
                $('.pin-wrap.' + destination.slug + ' .pin-content').addClass('open');

            },
            hideAllBubbles() {
                $('.pin-wrap').css('z-index', '1');
                $('.pin-wrap .pin-content').removeClass('open');
            },
            goToUrl(url) {
                console.log(url);
                window.location.href = url;
            },
            formatListItem(name, count) {
                return name + '<sup>' + count + '</sup>';
            }

        },
        mounted() {
            $('body').addClass('world-map');
        }
    };
</script>



// WEBPACK FOOTER //
// assets/js/components/taxonomy-destination/DestinationWorldMap.vue